// ОТВЕТЫ ШАГА 3 ПРИВЯЗАНЫ К ЭТАПУ — B5-F1 `3ea19875cbb881858677c536e3507ddd` (`s938.d6`–`d8`, `s972.d1`).
//
// Конверт хранит ответы деки ПОЗИЦИОННО: `sliders` / `text` / `buttons` / `cust` — массивы в порядке деки
// (старые первыми), а этапы шага 2 — в порядке экрана (новые первыми). Ряд экрана `i` ↔ ряд деки `N−1−i`
// (`toWizardInput.js`, `s485.d1`). Пока шаг 2 правил только `input.stages`, любое удаление, вставка или
// перенос даты сдвигали этапы относительно ответов: шапка чужого этапа над ответами, потерянный текущий этап,
// `misaligned` на сабмите (находка F-1 cc-164, qa блока 10 cc-193).
//
// ⭐ ПРИВЯЗКА — ПО ТОЖДЕСТВУ ОБЪЕКТА РЯДА, А НЕ ПО ИНДЕКСУ И НЕ ПО ДАТЕ. Писатели шага 2 строят новый список из
// тех же объектов рядов (`filter`, `restoreRow`, `commitDraft` — кроме правимого ряда), поэтому «где этот этап
// теперь» отвечается сравнением объектов. Правимый ряд `commitDraft` кладёт НОВЫМ объектом — его прежний объект
// передаётся явно (`alias`), иначе правка даты стирала бы ответы этапа. Возврат `undo` приносит ответы
// удалённого этапа сам (`restore`): в списке «до» его уже нет.
//
// ⭐ КОРОТКИЕ РЯДЫ — ЗАКОННЫ (`s972.d1` п. 3). После шага 2 конверт несёт `sliders: []`, панели B/C пишутся только
// при касании. Пустой массив остаётся пустым (дека ещё не открывалась); непустой выравнивается по новому списку,
// ряда нет — пустой ряд той же формы, что пишет дека (`StepThree.jsx` `rowAt` / `textAt` / `groupsAt` / `custAt`).
// Новый этап получает нетронутые ползунки — гейт его карточки закрыт, пока человек её не заполнит.

import { LAYERS } from '../../contracts.js';
import { GROUP_IDS } from '../toWizardInput.js';

/** Четыре массива ответов деки в конверте. */
export const ANSWER_ROWS = ['sliders', 'text', 'buttons', 'cust'];

const EMPTY = {
  sliders: () => LAYERS.map(() => null),
  text: () => ({ T1: '', T2: '', T3: '' }),
  buttons: () => Object.fromEntries(GROUP_IDS.map((id) => [id, []])),
  cust: () => '',
};

/**
 * Ответы деки одного этапа — по его ряду ЭКРАНА.
 * @param {object} input `session.input`
 * @param {number} screenIndex индекс ряда в `input.stages` (новые первыми)
 * @returns {{sliders?: any, text?: any, buttons?: any, cust?: any}} только те поля, что в конверте есть
 */
export function answersAt(input, screenIndex) {
  const n = input.stages.length;
  const d = n - 1 - screenIndex;
  const out = {};
  for (const key of ANSWER_ROWS) {
    const arr = input[key];
    if (Array.isArray(arr) && d >= 0 && d < arr.length) out[key] = arr[d];
  }
  return out;
}

/**
 * Новые массивы ответов под новый список этапов.
 *
 * @param {object} input `session.input` ДО правки (его `stages` — список «до», ответы — под него)
 * @param {Array} after список этапов ПОСЛЕ правки (порядок экрана, те же объекты рядов)
 * @param {{alias?: Map<object, object>, restore?: {row: object, answers: object}}} [opts]
 *   `alias` — новый объект ряда → его прежний объект (правка `✎`); `restore` — ряд, возвращённый `undo`, с ответами.
 * @returns {{sliders: Array, text: Array, buttons: Array, cust: Array}}
 */
export function carryAnswers(input, after, { alias = new Map(), restore = null } = {}) {
  const before = input.stages;
  const where = new Map(before.map((row, i) => [row, i]));
  const nb = before.length;
  const na = after.length;
  const out = {};
  for (const key of ANSWER_ROWS) {
    const arr = Array.isArray(input[key]) ? input[key] : [];
    const restoring = restore && restore.answers && key in restore.answers;
    if (arr.length === 0 && !restoring) { out[key] = []; continue; }
    out[key] = Array.from({ length: na }, (_, d) => {
      const row = after[na - 1 - d];
      if (restore && row === restore.row && restoring) return restore.answers[key];
      const old = where.has(row) ? where.get(row) : (alias.has(row) ? where.get(alias.get(row)) : undefined);
      if (old === undefined) return EMPTY[key]();
      const od = nb - 1 - old;
      return od < arr.length && arr[od] !== undefined ? arr[od] : EMPTY[key]();
    });
  }
  return out;
}
